/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import { Record } from 'immutable'
import AppDispatcher from '../../core/AppDispatcher'
import AccommodationInvoiceEvent from '../../event/AccommodationInvoiceEvent'
import Price from '../../domain/type/Price'
import AccommodationTaxStore from './AccommodationTaxStore'
import { AccommodationTaxState } from '../state/AccommodationTaxState'

class CreateViewState extends Record({
  accommodation_fee_paid: false,
  accommodation_tax_paid: false,
  accommodation_fee: 0,
  accommodation_tax: 0,
  note: ''
}) {}

class CreateViewStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new CreateViewState()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case AccommodationInvoiceEvent.createStart:
        // 初回ロード時
        return state.clear()

      case AccommodationInvoiceEvent.onEdit:
        const { name, value, reservation } = payload
        if (['accommodation_fee_paid', 'accommodation_tax_paid'].includes(name)) {
          if (name === 'accommodation_fee_paid' && value) {
            return state.merge({
              accommodation_fee_paid: value,
              accommodation_fee: reservation.accommodation_fee
            })
          }

          if (name === 'accommodation_tax_paid' && value) {
            const accommodation_tax_state = new AccommodationTaxState().buildBy(reservation)
            const accommodation_tax = accommodation_tax_state.calculate()
            return state.merge({
              accommodation_tax_paid: value,
              accommodation_tax
            })
          }

          return state.set(name, value)
        }

        if (['accommodation_fee', 'accommodation_tax'].includes(name)) {
          const price = new Price(value).val()
          return state.set(name, price)
        }

        return state.set(name, value)

      case AccommodationInvoiceEvent.onUpdateAccommodationTax:
        return state.set('accommodation_tax', payload.value)

      case AccommodationInvoiceEvent.onEditAccommodationTax:
        AppDispatcher.waitFor([AccommodationTaxStore.getDispatchToken()])
        const t = AccommodationTaxStore.getState()
        const accommodation_tax = t.tax_per_day * t.number_of_nights * t.number_of_guests
        return state.set('accommodation_tax', accommodation_tax)

      default:
        return state
    }
  }
}

export default new CreateViewStore()
